import { ref, reactive, computed, getCurrentInstance } from "vue";
import { defineStore } from "pinia";
import Ajax from "../../utilities/ajax";

const useAuth = defineStore("auth", () => {
  const $prebook = window.prebook;

  // auth user state
  const authUser = ref(window.prebook.customer || {});

  // check if user is authenticated
  const isAuthenticated = computed(() => (authUser.value.id ? true : false));

  const state = reactive({
    loading: false,
    errors: {},
  });

  // register form
  const registerForm = reactive({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    password: "",
  });

  // login form
  const loginForm = reactive({
    email: "",
    password: "",
  });

  const instance = getCurrentInstance();

  // Registration
  const submitRegisterForm = async () => {
    state.loading = true;

    const response = await Ajax.post("register_customer", {
      first_name: registerForm.first_name,
      last_name: registerForm.last_name,
      phone: registerForm.phone,
      email: registerForm.email,
      password: registerForm.password,
    });
    // Log('Register', response)

    if (response.success) {
      const props =
        instance.appContext.app.config?.globalProperties?.config || {};
      if (props) {
        localStorage.setItem("prebook_open", JSON.stringify(props));
      }

      authUser.value = response.data;
      $prebook.customer = response.data;
      $prebook.nonce = response.data.nonce;
      state.loading = false;
      setTimeout(() => {
        window.location.reload();
      }, 50);
      return authUser.value;
    } else {
      authUser.value = {};
      state.errors.message = response.message;
    }
    state.loading = false;
    return authUser.value;
  };

  // submit login form data
  const submitLoginForm = async () => {
    state.loading = true;
    const response = await Ajax.post("login_customer", {
      email: loginForm.email,
      password: loginForm.password,
    });
    // Log('Login', response.data)

    if (response.success) {
      const props =
        instance.appContext.app.config?.globalProperties?.config || {};
      if (props) {
        localStorage.setItem("prebook_open", JSON.stringify(props));
      }

      authUser.value = response.data;
      $prebook.customer = response.data;
      $prebook.nonce = response.data.nonce;
      state.loading = false;
      // $appointments.nextStep();
      setTimeout(() => {
        window.location.reload();
      }, 50);
    } else {
      authUser.value = {};
      state.errors.message = response.message;
    }

    state.loading = false;
    return authUser.value;
  };

  // export
  return {
    state,
    registerForm,
    loginForm,
    authUser,
    isAuthenticated,
    submitRegisterForm,
    submitLoginForm,
  };
});

export default useAuth;
